import { useQuery } from '@tanstack/react-query';
import { api } from './api-client';
import { loadSession } from './session';
import { isPersonalAnthropicApiKeyEnabled } from './personal-api-key';

export function useAiProvider() {
  const bootstrap = loadSession()?.bootstrap;
  const query = useQuery({
    queryKey: ['ai-provider', bootstrap?.workspace.id, bootstrap?.user?.id],
    queryFn: api.aiProvider,
  });
  return { ...query, usesPersonalKey: query.data?.enabled === true || isPersonalAnthropicApiKeyEnabled() };
}
